import React from "react";
import PricingBoxs from "../PricingBox/PricingBoxs";

function Pricing() {
  return (
    <>
      <div id="pricing" className="pricing-container">
        <div className="pricing-title-container">
          <p className="main-title pricing">
            PRICING<span className="dot">.</span>
          </p>
          <p className="pricing-desc-txt">
            You can't put a price on having a website that is completely
            customized to best fit with your brand.
          </p>
        </div>
        <div className="p-box-container">
          <PricingBoxs />
        </div>
      </div>
    </>
  );
}

export default Pricing;
